module.exports = __webpack_public_path__ + "static/quiz-a9fdb3b980bc38921d190b556133fde5.png";